module.exports = __webpack_public_path__ + "img/play.f4c6c920.svg";